import styled from 'styled-components';
import { ThemeColours } from '../../styles/ThemeColours';
import { Breakpoint, FontWeight, Orientation, ZIndex } from '../../styles/constants';
import { CTADot } from '../CTADot';
import { Link } from '../Link';

export const NavigationBarContainer = styled.div`
  align-items: center;
  background-color: white;
  border-top: 0.5px solid #d3dde1;
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 84px;
  justify-content: space-between;
  left: 0;
  min-height: 84px;
  position: fixed;
  right: 0;
  width: 100%;
  z-index: ${ZIndex.OVERLAY};
  ${Orientation.LANDSCAPE} {
    display: none;
  }

  ${Breakpoint.SMALL} {
    display: none;
  }
`;

export const NavigationBarInner = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: space-between;
`;

export const ButtonContainer = styled(Link)`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: relative;
  text-align: center;
  text-decoration: none;
  width: 75px;
`;

export const SearchButtonContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  width: 75px;
`;

export const TextContainer = styled.div`
  align-items: center;
  display: flex;
  height: 18px;
  padding-top: 4px;
`;

export const Text = styled.text`
  color: ${ThemeColours.mono600};
  font-size: 10px;
  font-weight: ${FontWeight.REGULAR};
  padding-top: 4px;
`;

export const TelehealthCTADot = styled(CTADot)`
  height: 8px;
  min-width: 8px;
  position: absolute;
  right: 17px;
  top: 12px;
`;
